import React, { useState, useRef } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { NavLink } from 'react-router-dom';

const styles = {
  container: {
    fontSize: 14,
    position: 'fixed',
    top: '11%',
    left: '35%',
    userSelect: 'none',
    display: 'flex',
    flexDirection: 'column',
    zIndex: '9999',
  },
  dropdown: {
    fontSize: 14,
    cursor: 'pointer',
    backgroundColor: '#F2F2F2',
    color: '#AAA',
    minWidth: '220px',
    width: 'auto',
    display: 'flex',
    borderRadius: '4px',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  arrowContainer: {
    backgroundColor: '#01b3b8',
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 8,
    borderRadius: '0px 4px 4px 0px',
  },
  arrowSvg: {
    width: 18,
    height: 18,
    fill: 'white',
    transition: 'transform 0.2s ease',
  },
  arrowOpen: {
    transform: 'rotate(180deg)',
  },
};

const LimitedZoneFilter = ({ zones = [] }) => {
  const [hoveredItem, setHoveredItem] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalPosition, setModalPosition] = useState({ x: 0, y: 0 });
  const dropdownRef = useRef(null);

  const handleClick = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setModalPosition({ x: rect.left, y: rect.top + rect.height});
    setShowModal(true);
    setTimeout(() => setShowModal(false), 4000); // stays visible longer
  };

  const displayText = 'Filter zones (All)';

  return (
    <div style={styles.container} ref={dropdownRef}>
      <div
        style={styles.dropdown}
        onClick={handleClick}
        title="Filter by document 1 zones (Premium Feature)"
      >
        <span>{displayText}</span>
        <div style={styles.arrowContainer}>
          <svg
            style={styles.arrowSvg}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M7 10l5 5 5-5z" />
          </svg>
        </div>
      </div>

      {showModal && (
        <Box
        sx={{
            position: 'fixed',
            top: '39%',
            left: '69%',
            transform: 'translate(-100%, -50%) scale(1)',
            bgcolor: '#fff',
            color: '#49a7ab',
            borderRadius: 2,
            boxShadow: 5,
            p: 1.5,
            zIndex: 9999,
            textAlign: 'center',
            minWidth: 500,
            whiteSpace: 'nowrap',
            animation: 'popout 0.2s ease',
        }}
        >
        <Typography
            variant="body1"
            sx={{ mb: 1, whiteSpace: 'nowrap', fontWeight: 500,  }}
        >
            Premium Functionality
        </Typography>
        <NavLink to="/accounts" style={{ textDecoration: 'none' }}>
            <Button
            variant="contained"
            sx={{
                bgcolor: '#49a7ab',
                color: '#fff',
                fontWeight: 600,
                fontSize: '.875rem',
                '&:hover': { bgcolor: '#42999d' },
            }}
            >
            Subscribe
            </Button>
        </NavLink>
        <style>
            {`
            @keyframes popout {
                0% { transform: translate(-100%, -50%) scale(0.7); opacity: 0; }
                100% { transform: translate(-100%, -50%) scale(1); opacity: 1; }
            }
            `}
        </style>
        </Box>
      )}
    </div>
  );
};

export default LimitedZoneFilter;
